import { Workflow, WorkflowAbstract } from '../../../types/workflow';

export default (workflow: WorkflowAbstract): Workflow => ({
  id: workflow.workflowId,
  name: workflow.name,
});
